/**
 * Created by valerasiestov on 05.11.15.
 */


if (!window.module) {
    window.module = {};
}

module.scroll = (function () {
    "use strict";

    function getScrollBarWidth() {
        var scrollDiv = document.createElement("div"),
            scrollbarWidth;

        scrollDiv.className = "scrollbar-measure";
        document.body.appendChild(scrollDiv);

        scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);

        return scrollbarWidth;
    }

    var list = [],
        scrollBarWidth = getScrollBarWidth();

    function Scroll(element) {
        var self = this,
            controls = {},
            handlers = {
                scroll: function (event) {
                    var target = event.target,
                        thumb = target.scrollThumb;

                    thumb.style.top = target.scrollTop / (target.scrollHeight / target.clientHeight) + 'px';
                },
                mouseEnter: function () {
                    var element = this,
                        thumb = element.scrollThumb,
                        scrollHeight;

                    thumb.classList.add('active');

                    scrollHeight = element.clientHeight /
                        (element.scrollHeight / element.clientHeight);

                    if (scrollHeight === element.clientHeight) {
                        scrollHeight = 0;
                    }

                    console.log(scrollHeight);

                    thumb.style.height = scrollHeight + 'px';
                },

                mouseLeave: function () {
                    this.scrollThumb.classList.remove('active');
                }
            };

        function setEventList() {

        }

        function getControls() {

            if (HEEL.browser.browser.chrome || HEEL.browser.browser.safari) {
                return;
            }

            var scrollElement = element.parentNode,
                scrollHeight = element.clientHeight /
                (element.scrollHeight / element.clientHeight),
                customScroll,
                customScrollButton;

            if (scrollHeight === scrollElement.clientHeight) {
                scrollHeight = 0;
            }

            customScroll = document.createElement('div');
            customScroll.className = 'custom-scroll-bar';
            customScroll.style.width = scrollBarWidth + 'px';

            customScrollButton = document.createElement('div');
            customScrollButton.className = 'custom-scroll-button';
            customScrollButton.style.height = scrollHeight + 'px';
            
            customScroll.appendChild(customScrollButton);
            
            element.scrollThumb = customScrollButton;
            
            element.addEventListener('scroll', handlers.scroll, false);
            element.addEventListener('mouseenter', handlers.mouseEnter, false);
            element.addEventListener('mouseleave', handlers.mouseLeave, false);

            scrollElement.appendChild(customScroll);
        }

        function init() {
            getControls();
            setEventList();
        }

        init();
    }

    function add(element) {
        list.push(new Scroll(element));
    }

    return {
        add: add
    };

}());

